import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";
import React, { ReactNode } from "react";

export interface Setting {
  title?: string;
  value: string;
  description?: string;
  content?: ReactNode;
  emoji?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

interface Props {
  settings: Setting[];
  value: string;
  grid?: boolean;
  showCheck?: boolean;
  setValue: (str: string) => void;
  padding?: string;
}

export default function RadioGroupList({ settings, value, grid = true, setValue, showCheck, padding }: Props): JSX.Element {
  return (
    <RadioGroup value={value} onChange={setValue}>
      <div className={`bg-white space-y-2 ${grid ? "grid sm:space-x-2 sm:space-y-0 sm:grid-cols-" + settings.length : ""}`}>
        {settings.map((setting) => (
          <RadioGroup.Option
            key={setting.value}
            disabled={setting.disabled}
            value={setting.value}
            className={({ checked, active }) =>
              classNames(
                checked ? "bg-cool-gray-50 border-primary-main col-span-1" : "border-gray-200",
                active ? "ring" : "",
                grid ? "" : "min-h-[75px]",
                setting.disabled ? "bg-gray-50 select-none cursor-not-allowed" : "cursor-pointer",
                padding ? padding : "px-4 py-6",
                "relative border  flex  rounded"
              )
            }
          >
            {({ active, checked }) => (
              <>
                {!!showCheck ? (
                  <div className={`w-4 ${grid ? "" : "my-auto"}`}>
                    <span
                      className={classNames(
                        checked ? "bg-primary-main border-transparent" : "bg-white border-gray-300",
                        active ? "ring-2 ring-offset-2 ring-primary-main" : "",
                        "h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center"
                      )}
                      aria-hidden="true"
                    >
                      <span className="rounded-full bg-white w-1.5 h-1.5" />
                    </span>
                  </div>
                ) : null}
                {setting.content ? (
                  setting.content
                ) : (
                  <div className="mx-3 flex flex-col">
                    <RadioGroup.Label as="span" className={classNames("text-gray-700 font-medium flex flex-row items-center mb-1")}>
                      {setting.emoji ? <div className="ml-2">{setting.emoji}&nbsp;</div> : null}
                      {setting.icon ?? null}
                      {setting.title}
                    </RadioGroup.Label>
                    <RadioGroup.Description as="span" className={classNames("text-gray-500 block text-sm")}>
                      {setting.description}
                    </RadioGroup.Description>
                  </div>
                )}
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}
